import { useMemo, useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Drawer } from 'vvs-uikit'
import { getUrlSearch, formatUrlSearch } from 'utils/urlSearch'
import { Search } from 'config/constants/paths'
import * as ga from 'utils/googleAnalyticsHelper'

import LeaderboardView from './LeaderboardView'
import { LeaderboardFAQ } from '../FAQ'

const Leaderboard: React.FC = () => {
  const { search } = useLocation()
  const leaderboard = useMemo(() => getUrlSearch(search, 'leaderboard'), [search])
  const history = useHistory()
  const leaderboardIsOpen = typeof leaderboard === 'string'

  useEffect(() => {
    if (leaderboardIsOpen) {
      ga.gotchiOpenLeaderboard()
    }
  }, [leaderboardIsOpen])

  return (
    <Drawer
      content={
        leaderboard === 'faq' ? (
          <LeaderboardFAQ />
        ) : (
          // leaderboard index
          <LeaderboardView />
        )
      }
      setIsOpen={() => undefined}
      isOpen={leaderboardIsOpen}
      onClose={() =>
        history.replace({
          search: formatUrlSearch([Search.VVS_GOTCHI_LEADERBOARD[0], null]), // remove leaderboard search param on url -> close leaderboard
        })
      }
    />
  )
}

export default Leaderboard
